import { create } from "zustand";

const useAbortControllerStore = create((set) => ({
    abortController: null,

    // Define um novo AbortController e cancela o anterior se existir
    setAbortController: (newAbortController) => set((state) => {
        if (state.abortController) {
            state.abortController.abort();
        }
        return { abortController: newAbortController };
    }),

    // Cancela a requisição atual e limpa o AbortController
    cancelRequest: () => set((state) => {
        if (state.abortController) {
            state.abortController.abort();
        }
        return { abortController: null };
    }),
}));

export default useAbortControllerStore;